/**
 * functions
 */
import { updateLazy } from "Functions/lazy";
import { initHeaderActionTippy, initTippy } from "Functions/tippy";
import smoothscroll from "smoothscroll-polyfill";
import { checkMaxStock } from "Functions/stock";

/**
 * common & components
 */
import "Common/validate-defaults";
import "Common/eshop";
import "Common/window";
import "Common/info-messages";
import "Common/form-addons";
import "Common/cookiebot";
import "Common/wishlist";
import "Common/toggle-password";

import "Common/product-cart-quantity";
import "Common/spinner-quick-update";

import "Components/modal/modal-back";
import "Components/modal/modal-jump";
import "Components/modal/modal-open-from-hash";

import "Components/header";
import "Components/footer";
import "Components/form/login";

/**
 * script
 */
window.Cart.customCallbacks.addedItem = function (form, response) {
    window.Event.dispatch("Custom.Cart.addedItem", { form, response });
};
window.Cart.customCallbacks.updatedItem = function (input, response) {
    window.Event.dispatch("Custom.Cart.updatedItem", { input, response });
};
window.Cart.customCallbacks.removedItem = function (form, response) {
    window.Event.dispatch("Custom.Cart.removedItem", { form, response });
};

window.updateLazy = updateLazy();

document.addEventListener("DOMContentLoaded", () => {
    updateLazy();
    initTippy();
    initHeaderActionTippy();
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-back").forEach((back) => {
        back.addEventListener("click", (event) => {
            if (event.currentTarget.getAttribute("href") == "#") {
                window.history.back();
            }
        });
    });

    // all rSpinners on change call checkMaxStock
    document.querySelectorAll(".spinner-wrapper").forEach((rSpinner) => {
        if (rSpinner.classList.contains("js-detail-quantity")) {
            return;
        }

        const handleSpinnerEvent = (event) => {
            const quantity = event.detail.rSpinner.getParsedValue();
            const maxStock = event.detail.rSpinner.querySelector(".c-form__input").dataset.stock;

            checkMaxStock(quantity, maxStock);
        };

        rSpinner.addEventListener("changed", handleSpinnerEvent);
        rSpinner.addEventListener("spin", handleSpinnerEvent);
    });
});

smoothscroll.polyfill();
